<div class="align-items-center title-purchases mobile" *ngIf="!loadingPage && !isNotProfile">
  <span (click)="backTab()"><i class="icon-back fa-light fa-arrow-left"></i></span>
  <p class="name-profile m-0" (click)="backTab()">Atrás</p>
</div>
<div class="flex-cont" [ngClass]="{'flex-faqs': isNotProfile}">

  <div class="container" [ngClass]="{'not-profile': isNotProfile}">
    <div class="faqs-page" *ngIf="!loadingPage">
      <p class="h2 faqs-title">Preguntas frecuentes</p>
      <div class="faqs-accordion">
        <mat-accordion class="faq-item" multi>
          <mat-expansion-panel *ngFor="let faq of faqs" [ngClass]="{'mat-expansion-panel': !isNotProfile}" [ngClass]="{'mat-expansion': isNotProfile}">
            <mat-expansion-panel-header>
              <mat-panel-title>{{ faq.acf.question }}</mat-panel-title>
            </mat-expansion-panel-header>
            <div [innerHTML]="faq.acf.descripcion"></div>
          </mat-expansion-panel>
        </mat-accordion>
      </div>
    </div>
    <div class="loading-container" *ngIf="loadingPage">
        <ng-lottie class="lottie" [options]="loadingLottie" containerClass="loading-box"></ng-lottie>
    </div>
  </div>
</div>
